import { useState } from "react";
import TextInput from "../../textinput/textInput";
import { findBestRnBkGrids } from "./gridFinder-util";
import { TbHexagonNumber1, TbHexagonNumber2, TbHexagonNumber3 } from "react-icons/tb";
import { FaCheck } from "react-icons/fa";
import { rnbkDesiredRes } from "../../../regex/REGEX";
import "./gridFinder.css";

function GridFinder({ updateStateField }) {
    const [targetRes, setTargetRes] = useState("");
    const [closeGrids, setCloseGrids] = useState([]);
    const [buttonContents, setButtonContents] = useState([<p>Apply</p>, <p>Apply</p>, <p>Apply</p>]);

    const handleUpdateTargetRes = (field, value) => {
        setTargetRes(value);
        setCloseGrids(findBestRnBkGrids(value))
    }

    const numberIcons = (index) => {
        const size = "26px";
        const array = [
            <TbHexagonNumber1 size={size} />,
            <TbHexagonNumber2 size={size} />,
            <TbHexagonNumber3 size={size} />,
        ]
        return array[index];
    }

    const handleApply = (index, grid) => {
        const newArray = buttonContents.map((_, idx) => {
            if (idx === index) {
                return <FaCheck size={"20px"} />
            } else {
                return <p>Apply</p>
            }
        });
        setButtonContents(newArray);
        updateStateField("grid_root", grid.n)
        updateStateField("grid_level", grid.k - 1)
    }

    return (
        <div className="grid-finder-container">
            <h3 className="grid-finder-title">RnBk Finder Tool</h3>
            <TextInput
                label={"Desired Resolution"}
                field={"resolution"}
                value={targetRes}
                tooltipMessage={"Enter the target resolution in km"}
                updateStateField={handleUpdateTargetRes}
                validRegex={rnbkDesiredRes}
                allowRegex={/^[0-9.]*$/}
                placeholder={"resolution in km"}
            />
            {
                closeGrids.length > 0 &&
                closeGrids.map((grid, index) => {
                    return (
                        <div className="close-grid-entry" key={index}>
                            {numberIcons(index)}
                            <p>RnBk grid: R{grid.n}B{grid.k}</p>
                            <p>Approx. mesh size: {Math.round(grid.meshSize * 10)/10} km</p>
                            <p>Error ± {Math.round(grid.error*10)/10} km</p>
                            <button onClick={() => handleApply(index, grid)} className="apply-button">{buttonContents[index]}</button>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default GridFinder;
